import React from 'react';
import './MainGoal.scss';
import { useMediaQuery } from 'react-responsive';
import { safeHtml } from '../../../../services/helpers';

export default function MainGoal({ content, isAtelier }) {
    const isInf480 = useMediaQuery({ maxWidth: 480 });
    const isInf768 = useMediaQuery({ maxWidth: 767 });
    const isInf1024 = useMediaQuery({ maxWidth: 1024 });
    const isSmallMobile = useMediaQuery({ maxWidth: 600 });

    return (
        <div
            id="workshop-main-goal"
            className='workshop-main-goal'
            style={{
                padding: isAtelier ?
                    isInf768 ? '2rem 0.5rem' :
                    isInf1024 ? '3rem 1rem' :
                    '4rem 1rem'
                :
                isInf480 ? '1rem 1rem' :
                isInf768 ? '2rem 1.5rem' :
                '2.5rem 2rem',
            }}
        >
            {isSmallMobile ?
                <div
                    className="" 
                    dangerouslySetInnerHTML={safeHtml(content.TexteMobile)}
                />
            :
                <div
                    className=""
                    dangerouslySetInnerHTML={safeHtml(content.Texte)}
                />
            }
        </div>
    )
}
